<div class="root-container">
  <label class="toggle"
    [ngClass]="{
      'disabled': disabled(),
      'checked': checked()
    }"
    (click)="toggle()"
    (keydown.enter)="toggle()"
    (keydown.space)="toggle()"
    role="switch"
    tabindex="1">

    <span class="slider"></span>
  </label>
  <input type="checkbox" [checked]="checked()" [disabled]="disabled()" hidden>
</div>
